module.exports = __webpack_public_path__ + "img/eventIcon.3a0454bf.svg";